var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showAIProcessLoading,
          expression: "showAIProcessLoading",
        },
      ],
      staticClass: "download-loading",
    },
    [
      _c("div", { staticClass: "download-loading__content" }, [
        _c("div", { staticClass: "download-loading__lottie" }, [
          _c(
            "svg",
            {
              staticStyle: { "user-select": "none" },
              attrs: {
                id: "aiLoaderSvg",
                viewBox: "0 0 400 400",
                width: "100%",
                height: "100%",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("circle", {
                staticClass: "signal-wave",
                attrs: {
                  cx: "180",
                  cy: "105",
                  r: "18",
                  fill: "none",
                  stroke: "#f95e49",
                },
              }),
              _c("circle", {
                staticClass: "signal-wave",
                staticStyle: { "animation-delay": "0.4s" },
                attrs: {
                  cx: "180",
                  cy: "105",
                  r: "18",
                  fill: "none",
                  stroke: "#f95e49",
                },
              }),
              _c("circle", {
                staticClass: "signal-wave",
                staticStyle: { "animation-delay": "0.8s" },
                attrs: {
                  cx: "180",
                  cy: "105",
                  r: "18",
                  fill: "none",
                  stroke: "#f95e49",
                },
              }),
              _c("g", { staticClass: "anim-twinkle-1" }, [
                _c("path", {
                  attrs: {
                    d: "M 130,68 Q 130,80 142,80 Q 130,80 130,92 Q 130,80 118,80 Q 130,80 130,68 Z",
                    fill: "#f3b723",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                    "stroke-linejoin": "round",
                  },
                }),
              ]),
              _c("g", { staticClass: "anim-twinkle-2" }, [
                _c("path", {
                  attrs: {
                    d: "M 320,198 Q 320,210 332,210 Q 320,210 320,222 Q 320,210 308,210 Q 320,210 320,198 Z",
                    fill: "#f3b723",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                    "stroke-linejoin": "round",
                  },
                }),
              ]),
              _c("g", { staticClass: "bubble-sway" }, [
                _c("path", {
                  attrs: {
                    d: "M 228,30\n                       H 342\n                       A 18,18 0 0,1 360,48\n                       V 102\n                       A 18,18 0 0,1 342,120\n                       H 260\n                       L 205,150\n                       L 235,120\n                       H 228\n                       A 18,18 0 0,1 210,102\n                       V 48\n                       A 18,18 0 0,1 228,30 Z",
                    fill: "#f3b723",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                    "stroke-linejoin": "round",
                    "stroke-linecap": "round",
                  },
                }),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "285",
                      y: "68",
                      "font-family": "'Inconsolata', monospace, sans-serif",
                      "font-size": "28",
                      "font-weight": "900",
                      fill: "#1d1d1d",
                      "text-anchor": "middle",
                      "letter-spacing": "4",
                    },
                  },
                  [
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-1", attrs: { id: "bin0_0" } },
                      [_vm._v("0")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-2", attrs: { id: "bin0_1" } },
                      [_vm._v("1")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-3", attrs: { id: "bin0_2" } },
                      [_vm._v("0")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-4", attrs: { id: "bin0_3" } },
                      [_vm._v("1")]
                    ),
                  ]
                ),
                _c(
                  "text",
                  {
                    attrs: {
                      x: "285",
                      y: "100",
                      "font-family": "'Inconsolata', monospace, sans-serif",
                      "font-size": "28",
                      "font-weight": "900",
                      fill: "#1d1d1d",
                      "text-anchor": "middle",
                      "letter-spacing": "4",
                    },
                  },
                  [
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-4", attrs: { id: "bin1_0" } },
                      [_vm._v("1")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-3", attrs: { id: "bin1_1" } },
                      [_vm._v("0")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-2", attrs: { id: "bin1_2" } },
                      [_vm._v("1")]
                    ),
                    _c(
                      "tspan",
                      { staticClass: "bin-flicker-1", attrs: { id: "bin1_3" } },
                      [_vm._v("0")]
                    ),
                  ]
                ),
              ]),
              _c("g", { staticClass: "anim-float" }, [
                _c("rect", {
                  attrs: {
                    x: "160",
                    y: "284",
                    width: "40",
                    height: "25",
                    fill: "#a4abb6",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                    "stroke-linejoin": "round",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "180",
                    y1: "160",
                    x2: "180",
                    y2: "120",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                    "stroke-linecap": "round",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "100",
                    y: "160",
                    width: "160",
                    height: "130",
                    rx: "20",
                    ry: "20",
                    fill: "var(--robot-body)",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                    "stroke-linejoin": "round",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 112,255 L 112,182 A 10,10 0 0,1 122,172",
                    fill: "none",
                    stroke: "var(--robot-body-highlight)",
                    "stroke-width": "5",
                    "stroke-linecap": "round",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 115,275 L 245,275",
                    fill: "none",
                    stroke: "var(--robot-body-shadow)",
                    "stroke-width": "5",
                    "stroke-linecap": "round",
                  },
                }),
                _c("circle", {
                  staticClass: "red-pulse",
                  attrs: {
                    cx: "180",
                    cy: "105",
                    r: "18",
                    fill: "#f95e49",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                  },
                }),
                _c("circle", {
                  attrs: { cx: "174", cy: "99", r: "4", fill: "#ffffff" },
                }),
                _c("circle", {
                  staticClass: "eye-blink",
                  attrs: {
                    cx: "145",
                    cy: "215",
                    r: "22",
                    fill: "#ffffff",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                  },
                }),
                _c("circle", {
                  staticClass: "eye-blink-right",
                  attrs: {
                    cx: "215",
                    cy: "215",
                    r: "22",
                    fill: "#ffffff",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                  },
                }),
                _c("rect", {
                  attrs: {
                    x: "132",
                    y: "250",
                    width: "96",
                    height: "20",
                    rx: "10",
                    fill: "#ffffff",
                    stroke: "#1d1d1d",
                    "stroke-width": "6",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "151",
                    y1: "250",
                    x2: "151",
                    y2: "270",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "170",
                    y1: "250",
                    x2: "170",
                    y2: "270",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "190",
                    y1: "250",
                    x2: "190",
                    y2: "270",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                  },
                }),
                _c("line", {
                  attrs: {
                    x1: "209",
                    y1: "250",
                    x2: "209",
                    y2: "270",
                    stroke: "#1d1d1d",
                    "stroke-width": "4",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 108,245 A 2,2 0 0,1 112,245",
                    fill: "none",
                    stroke: "#ffffff",
                    "stroke-width": "4",
                    "stroke-linecap": "round",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M 248,245 A 2,2 0 0,1 252,245",
                    fill: "none",
                    stroke: "#ffffff",
                    "stroke-width": "4",
                    "stroke-linecap": "round",
                  },
                }),
              ]),
            ]
          ),
        ]),
        _c("p", { staticClass: "download-loading__text" }, [
          _vm._v(
            " " +
              _vm._s(
                _vm.showAIProcessLoadingText ||
                  "資料處理中，請不要離開此畫面，感謝您的耐心等候。"
              ) +
              " "
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }